<template>
    <div class="col-12">
        <div class="input-group mb-3">
            <input aria-describedby="basic-addon1" aria-label=""
                   class="form-control col-form-label-lg"
                   name="search" placeholder="Rechercher" type="text" v-model="query" v-on:input="search(false)">
            <div class="input-group-append">
                <button class="btn btn-primary" dusk="search_button" type="button" v-on:click="search(false)">Rechercher
                </button>
            </div>
        </div>
        <small class="form-text text-muted">
            Nombre de résultats affichés : <i class='fas fa-circle-notch fa-spin' v-if="loading"></i> <span
                v-if="!loading">{{ (response['total'] > 0) ? '1 - ' + response['to'] +
            '(total: ' + response['total'] + ')' : '0'}}</span>
        </small>
        <div class="row mt-5">
            <div class="col-12 col-md-2">
                <div class="custom-control custom-checkbox">
                    <input class="custom-control-input" id="customControlInline" type="checkbox" v-model="closed"
                           :disabled="loading" v-on:change="search(false)">
                    <label class="custom-control-label" for="customControlInline">Fermé</label>
                </div>

                <h6 class="mt-3">Type d'équipements:</h6>
                <div class="form-check custom-checkbox custom-control" v-for="(badge, index) in equipments">
                    <input class="custom-control-input" type="checkbox" v-bind:checked="!badge['disabled']"
                           :disabled="loading" v-bind:id="'t' + index" v-bind:name="badge['id']"
                           v-on:click="inverseBadge(index, equipments)">
                    <label class="custom-control-label" v-bind:for="'t' + index">
                        {{ badge['name']}}
                    </label>
                </div>
                <div v-if="companies.length > 0">
                    <h6 class="mt-3">Clients:</h6>
                    <div class="form-check custom-checkbox custom-control" v-for="(badge, index) in companies">
                        <input :disabled="loading" class="custom-control-input" type="checkbox"
                               v-bind:checked="!badge['disabled']" v-bind:id="'c' + index" v-bind:name="badge['id']"
                               v-on:click="inverseBadge(index, companies)"/>
                        <label class="custom-control-label" v-bind:for="'c' + index">
                            {{ badge['name']}} <span v-if="badge['main'].length > 0">({{ badge['main'][0]['name_formatted']}})</span>
                        </label>
                    </div>
                </div>
                <div v-if="equipments_company.length > 0">
                    <h6 class="mt-3">Équipements:</h6>
                    <div class="form-check custom-checkbox custom-control" v-for="(badge, index) in equipments_company">
                        <input :disabled="loading" class="custom-control-input" type="checkbox"
                               v-bind:checked="!badge['disabled']" v-bind:id="'e' +index" v-bind:name="badge['id']"
                               v-on:click="inverseBadge(index, equipments_company)"/>
                        <label class="custom-control-label" v-bind:for="'e' + index">
                            {{ badge['type']['name']}} - {{ badge['location'] }}
                        </label>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-10">
                <div class="table-responsive">
                    <table class="table table-hover">
                        <thead>
                        <tr>
                            <th v-for="(column, index) in columns" v-on:click="sortBy(index)">
                                <span style="cursor: pointer;">{{ column['name'] }}</span>
                                <span v-if="column['orderable']">
                            <i class="fas fa-arrow-down fa-sm"
                               v-bind:class="{'text-danger': sortCell === index && column['sortDirection'] === 1}"></i>
                            <i class="fas fa-arrow-up fa-sm"
                               v-bind:class="{'text-danger': sortCell === index && column['sortDirection'] === -1}"></i>

                        </span>
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-if="loading && page === 1">
                            <td colspan="7"><i class="fas fa-circle-notch fa-spin"></i> Chargement des données en cours
                            </td>
                        </tr>
                        <tr v-if="data.length === 0 && loading === false">
                            <td colspan="7">Aucun ticket ne correspond à vos critères de recherche.</td>
                        </tr>
                        <tr v-for="entry in filteredResults" v-if="!loading || page > 1">
                            <th scope="row">{{ entry['number']}}</th>
                            <td>{{ entry['created_at'] | moment('DD/MM/YYYY')}}</td>
                            <td><a v-bind:href="'equipments/' + entry['equipment']['id']">{{
                                entry['equipment']['type']['name']}} {{ entry['equipment']['location'] }}</a></td>
                            <td><a v-bind:href="'companies/' + entry['company']['id']">{{ entry['company']['name']
                                }}</a></td>
                            <td>{{ entry['subject']}}</td>
                            <td>{{ entry['status_text'] }}</td>
                            <td><a v-bind:href="'assistance/' + entry['id']">Détails</a></td>
                        </tr>
                        <tr v-if="!loading && data.length !== 0 && response['last_page'] > page">
                            <td colspan="6" id="loadMore" v-on:click="loadMore">Charger plus ...</td>
                        </tr>
                        <tr v-if="loading && data.length !== 0 && response['last_page'] > page">
                            <td colspan="6"><i class="fas fa-circle-notch fa-spin"></i> Chargement des prochains
                                résultats en cours
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['equipments_id', 'companies_id', 'equipments_company_id'],
        data: function () {
            return {
                sortCell: '',
                loading: true,
                query: '',
                data: [],
                equipments: [],
                companies: [],
                equipments_company: [],
                closed: false,
                page: 1,
                response: [],
                columns: {
                    'id': {
                        name: '#',
                        db_name: 'number',
                        orderable: true,
                        sortDirection: 1,
                        type: 'number'
                    },
                    'date': {
                        name: 'Date',
                        db_name: 'created_at',
                        orderable: true,
                        sortDirection: 1,
                        type: 'date'
                    },
                    'equipment': {
                        name: 'Écran',
                        db_name: 'equipment.location',
                        orderable: false,
                        sortDirection: 1,
                        type: 'text'
                    },
                    'company': {
                        name: 'Client',
                        db_name: 'company.name',
                        orderable: false,
                        sortDirection: 1,
                        type: 'text'
                    },
                    'intitule': {
                        name: 'Intitulé',
                        db_name: 'subject',
                        orderable: true,
                        sortDirection: 1,
                        type: 'text'
                    },
                    'status': {
                        name: 'Statut',
                        db_name: 'status',
                        orderable: false,
                        sortDirection: 1,
                        type: 'text'
                    },
                    'details': {
                        name: 'Détails',
                        db_name: '',
                        orderable: false,
                        sortDirection: 1,
                        type: ''
                    },
                },
            }
        },
        filters: {
            displayDate: function (value) {
                var parts = value.split(' ')[0].split('-');
                var date = new Date(parts[0], parts[1], parts[2]);
                return ('0' + date.getDate()).slice(-2) + '/' + ('0' + date.getMonth()).slice(-2) + '/' + date.getFullYear();
            },
        },
        computed: {
            filteredResults: function () {
                var data = this.data;
                if (this.sortCell) {
                    var cell = this.columns[this.sortCell];
                    var direction = cell['sortDirection'];
                    if (cell['type'] === 'date') {
                        data = data.slice().sort(function (a, b) {
                            var a1 = new Date(a[cell['db_name']]);
                            var b1 = new Date(b[cell['db_name']]);

                            return (a1.getTime() === b1.getTime()) ? 0 : ((a1.getTime() > b1.getTime()) ? 1 : -1) * cell['sortDirection'];
                        });
                    } else if (cell['type'] === 'number') {
                        data = data.slice().sort(function (a, b) {
                            var a1 = a[cell['db_name']];
                            var b1 = b[cell['db_name']];

                            return (a1 === b1) ? 0 : ((a1 > b1) ? 1 : -1) * cell['sortDirection'];
                        });
                    } else if (cell['type'] === 'text') {
                        data = data.slice().sort(function (a, b) {
                            var a1 = a[cell['db_name']];
                            var b1 = b[cell['db_name']];

                            return (a1 === b1) ? 0 : ((a1 > b1) ? 1 : -1) * cell['sortDirection'];
                        });
                    }
                }
                return data;
            },
        },
        mounted: function () {
            axios.post('equipments/available', {})
                .then(response => {
                    this.equipments = response.data;
                    this.equipments.forEach(function (item) {
                        if (this.equipments_id.length > 0) {
                            if (this.equipments_id.indexOf(item['id']) < 0) {
                                item['disabled'] = true;
                            } else {
                                item['disabled'] = false;
                            }
                        } else {
                            item['disabled'] = false;
                        }

                    }.bind(this));


                    if (this.companies_id.length > 0) {
                        axios.post('companies/json', {companies: this.companies_id})
                            .then(response => {
                                this.companies = response.data;
                                this.companies.forEach(function (item) {
                                    if (this.companies_id.length > 0) {
                                        if (this.companies_id.indexOf(item['id']) < 0) {
                                            item['disabled'] = true;
                                        } else {
                                            item['disabled'] = false;
                                        }
                                    } else {
                                        item['disabled'] = false;
                                    }
                                }.bind(this));

                                axios.post('companies/' + this.companies[0]['id'] + '/equipments', {})
                                    .then(response => {
                                        this.equipments_company = response.data;
                                        this.equipments_company.forEach(function (item) {
                                            if (this.equipments_company_id.length > 0) {
                                                if (this.equipments_company_id.indexOf(item['id']) < 0) {
                                                    item['disabled'] = true;
                                                } else {
                                                    item['disabled'] = false;
                                                }
                                            } else {
                                                item['disabled'] = false;
                                            }

                                        }.bind(this));
                                        this.search();
                                    });

                            });
                    } else {
                        this.search();
                    }

                });


        },
        created: function () {
            window.addEventListener('scroll', this.handleScroll);
        },
        destroyed: function () {
            window.removeEventListener('scroll', this.handleScroll);
        },
        methods: {
            handleScroll: function () {
                if (!this.loading) {
                    if (document.getElementById('loadMore') != null && this.isInViewport(document.getElementById('loadMore'))) {
                        this.loadMore();
                    }
                }
            },
            isInViewport: function (elem) {
                var bounding = elem.getBoundingClientRect();
                return (
                    bounding.top >= 0 &&
                    bounding.left >= 0 &&
                    bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                    bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
                );
            },
            loadMore: function () {
                this.page++;
                this.search(true);
            },
            sortBy: function (index) {
                if (this.columns[index]['orderable'] === true) {
                    this.sortCell = index;
                    this.columns[index]['sortDirection'] *= -1;
                }
            },
            inverseBadge: function (index, arr) {
                arr[index]['disabled'] = !arr[index]['disabled'];
                this.$forceUpdate();
                this.search(false);
            },
            search: function (next_page = false) {
                this.loading = true;
                if (!next_page) {
                    this.page = 1;
                    this.data = [];
                }
                var equipments_id = [];
                this.equipments.forEach(function (item) {
                    if (!item['disabled']) {
                        equipments_id.push(item['id']);
                    }
                });
                var companies_id = [];
                this.companies.forEach(function (item) {
                    if (!item['disabled']) {
                        companies_id.push(item['id']);
                    }
                });
                var equipments_company_id = [];
                this.equipments_company.forEach(function (item) {
                    if (!item['disabled']) {
                        equipments_company_id.push(item['id']);
                    }
                });
                axios
                    .post('assistance/search', {
                        query: this.query,
                        equipments: equipments_id,
                        closed: this.closed,
                        companies: companies_id,
                        equipments_company: equipments_company_id,
                        page: this.page
                    })
                    .then(response => {
                        if (next_page) {
                            this.data = this.data.concat(response.data.data);
                        } else {
                            this.data = response.data.data;
                        }
                        this.response = response.data;
                        this.loading = false;
                    });

            },
        }
    }
</script>
